module.exports = __webpack_public_path__ + "img/img1.ba4ee98a.jpg";